import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'isomorphic-fetch';
import './setReactGlobals'; // must run before App so vendor shims see __SAVIYNT_MFE_REACT__ / __SAVIYNT_MFE_REACT_DOM__
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import App from './ui-home/src/App';
import * as serviceWorker from './serviceWorker';
import AppHeader from './ui-home/src/AppHeader';
import './ECMv6/assets/css/global.css';
import IdentitiesVerification from 'ui-home/src/IdentitiesVerification';
import { injectTokens } from '@saviynt/tokens';
import { legacyLibraryRenderPaths } from 'ui-home/src/Constants';

injectTokens();

const isLegacyPath = legacyLibraryRenderPaths.some(path => window.location.pathname.includes(path));

if (process.env.REACT_APP_MODE !== 'ECM') {
  if (
    window.location.pathname.indexOf('/identities/idproofing/request') > 0 &&
    window.location.search.indexOf('key') > 0
  ) {
    if(isLegacyPath){
      ReactDOM.render(<IdentitiesVerification />,document.getElementById('root'));
    }else{
      const root = createRoot(document.getElementById('root'));
      root.render(<IdentitiesVerification />);
    }
  } else {
    if(isLegacyPath){
      ReactDOM.render(<App />,document.getElementById('root'));
    }else{
      const root = createRoot(document.getElementById('root'));
      root.render(<App />);
    }
  }
} else {
  if(isLegacyPath){
    ReactDOM.render(<AppHeader />,document.getElementById('header'));
  }else{
    const headerRoot = createRoot(document.getElementById('header'));
    headerRoot.render(<AppHeader />);
  }
}

serviceWorker.unregister();
